import React, { useState, useCallback, useEffect } from 'react';
import carousel1 from "../asset/image.jpg";
import carousel2 from "../asset/image2.jpg";
import carousel3 from "../asset/image3.jpg";

const SLIDE_INTERVAL = 3000; // 3 seconds
const SWIPE_THRESHOLD = 50;

const CAROUSEL_SLIDES = [
  {
    image: carousel1,
    text: "Maysam is Here\nNow",
    textPosition: "top-right",
    textColor: "text-black",
    buttonPosition: "bottom"
  },
  {
    image: carousel2,
    text: "Discover Your\nUnique Style with\nmaysam",
    textPosition: "top-right",
    textColor: "text-white",
    buttonPosition: "bottom"
  },
  {
    image: carousel3,
    text: "Explore Maysam\nExclusive Collection",
    textPosition: "top-left",
    textColor: "text-white",
    buttonPosition: "bottom"
  }
];

const Carousel = () => {
  const [state, setState] = useState({
    currentSlide: 0,
    direction: 'next' as 'next' | 'prev',
    isTransitioning: false,
    touchStart: 0,
    touchEnd: 0
  });

  const handleTransitionEnd = useCallback(() => {
    setState(prev => ({ ...prev, isTransitioning: false }));
  }, []);

  const handleSlideChange = useCallback((newIndex: number, newDirection: 'next' | 'prev') => {
    if (!state.isTransitioning) {
      setState(prev => ({
        ...prev,
        isTransitioning: true,
        direction: newDirection,
        currentSlide: newIndex
      }));
    }
  }, [state.isTransitioning]);

  const handlePrevSlide = useCallback(() => {
    const newIndex = (state.currentSlide - 1 + CAROUSEL_SLIDES.length) % CAROUSEL_SLIDES.length;
    handleSlideChange(newIndex, 'prev');
  }, [state.currentSlide, handleSlideChange]);

  const handleNextSlide = useCallback(() => {
    const newIndex = (state.currentSlide + 1) % CAROUSEL_SLIDES.length;
    handleSlideChange(newIndex, 'next');
  }, [state.currentSlide, handleSlideChange]);

  const handleTouch = useCallback((type: 'start' | 'move' | 'end', x?: number) => {
    setState(prev => {
      if (type === 'start' && x !== undefined) {
        return { ...prev, touchStart: x, touchEnd: x };
      } else if (type === 'move' && x !== undefined) {
        return { ...prev, touchEnd: x };
      } else if (type === 'end') {
        if (prev.touchStart > prev.touchEnd + SWIPE_THRESHOLD) {
          handleNextSlide();
        } else if (prev.touchStart < prev.touchEnd - SWIPE_THRESHOLD) {
          handlePrevSlide();
        }
        return { ...prev, touchStart: 0, touchEnd: 0 };
      }
      return prev;
    });
  }, [handleNextSlide, handlePrevSlide]);

  const getSlideClass = useCallback((index: number) => {
    if (index === state.currentSlide) return 'translate-x-0 z-10';

    if (state.direction === 'next') {
      return index === (state.currentSlide + 1) % CAROUSEL_SLIDES.length
        ? 'translate-x-full z-0'
        : '-translate-x-full z-0';
    }
    return index === (state.currentSlide - 1 + CAROUSEL_SLIDES.length) % CAROUSEL_SLIDES.length
      ? '-translate-x-full z-0'
      : 'translate-x-full z-0';
  }, [state.currentSlide, state.direction]);

  const getTextPositionClass = (position: string) => {
    switch (position) {
      case 'top-right':
        return 'absolute top-4 right-4  sm:top-10 sm:right-10 text-right';
      case 'top-left':
        return 'absolute top-4 left-4 sm:top-10 sm:left-10 text-left';
      case 'bottom-center':
        return 'absolute bottom-4 left-4 right-4 sm:bottom-10 sm:left-10 sm:right-10 text-center';
      default:
        return 'absolute bottom-4 left-4 right-4 sm:bottom-10 sm:left-10 sm:right-10 text-center';
    }
  };

  const getButtonPositionClass = (position: string) => {
    switch (position) {
      case 'bottom':
        return 'absolute bottom-4 left-4 right-4 sm:bottom-10 sm:left-10 sm:right-10 flex justify-center';
      default:
        return 'absolute bottom-4 left-4 right-4 sm:bottom-10 sm:left-10 sm:right-10 flex justify-center';
    }
  };

  useEffect(() => {
    const timer = setInterval(handleNextSlide, SLIDE_INTERVAL);
    return () => clearInterval(timer);
  }, [handleNextSlide]);

  return (
    <div className="relative h-[88vh] overflow-hidden bg-black">
      {CAROUSEL_SLIDES.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-transform duration-500 ease-in-out ${getSlideClass(index)}`}
          onTransitionEnd={index === state.currentSlide ? handleTransitionEnd : undefined}
        >
          <img
            src={slide.image}
            alt={`Carousel slide ${index + 1}`}
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: "center top" }}
          />
          <div className={getTextPositionClass(slide.textPosition)}>
            <h1 className={`font-montserrat text-xl sm:text-2xl md:text-3xl lg:text-5xl font-semibold
                          uppercase leading-tight ${slide.textColor}`}>
              {slide.text.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i < slide.text.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </h1>
          </div>
          <div className={getButtonPositionClass(slide.buttonPosition)}>
            <button
              onClick={() => window.location.href = "/collection"}
              className="px-4 py-2 sm:px-6 sm:py-3 bg-white border-[1px] border-white text-black rounded-full
                        hover:bg-transparent hover:text-white hover:border-[1px] hover:border-white transition-colors duration-300"
            >
              Shop Now
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Carousel;
